'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_Inputs$$anon$1(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_ui_Inputs$$anon$1 as $c_Lpresto_ui_Inputs$$anon$1 };
$p = $c_Lpresto_ui_Inputs$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_Inputs$$anon$1;
/** @constructor */
function $h_Lpresto_ui_Inputs$$anon$1() {
}
export { $h_Lpresto_ui_Inputs$$anon$1 as $h_Lpresto_ui_Inputs$$anon$1 };
$h_Lpresto_ui_Inputs$$anon$1.prototype = $p;
$p.bN = (function(str) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(str);
});
$p.bJ = (function(t) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(t);
});
var $d_Lpresto_ui_Inputs$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_Inputs$$anon$1, "presto.ui.Inputs$$anon$1", ({
  a3Q: 1,
  K: 1
}));
export { $d_Lpresto_ui_Inputs$$anon$1 as $d_Lpresto_ui_Inputs$$anon$1 };
//# sourceMappingURL=presto.ui.-Inputs$$anon$1.js.map
